import Blue from "~/core";

new Blue({
	name: 'Header Nav Menu',
  selector: ".header",
  setup(header) {
		const nav = header.querySelector('.header__nav');
		const trigger = header.querySelector('.header__triggerInner');
		const links = [...header.querySelectorAll('a')];

		const open = () => {
			header.classList.add('is-open');
			this.$scrollLock.lock(header);
		}
		const close = () => {
			header.classList.remove('is-open');
			this.$scrollLock.unlock(header);
		}
		const toggle = () => {
			if (header.classList.contains('is-open')) {
				close();
			}
			else {
				open();
			}
		}

		setTimeout(() => {
			header.classList.remove('preload');
		}, 500);

		trigger?.addEventListener('click', toggle);
		links?.forEach(link => link.addEventListener('click', close));
  }
});

new Blue({
	name: 'Header Popup',
  selector: "[data-header-popup-trigger]",
  setup(trigger) {
		const header = trigger.closest('.header');
		const backdrop = this.$createElement({tag: 'div', attributes: {class: 'header__popupWrap'}});
		const container = this.$createElement({tag: 'div', attributes: {class: 'header__popupContainer'}});
		const dismiss = this.$createElement({tag: 'div', attributes: {class: 'header__popupDismiss'}});
		const content = header.querySelector('.header__popup')?.cloneNode(true)

		const main = document.querySelector('main.content');

		if (!content) {
			return;
		}
		
		content.removeAttribute('style')

		backdrop.insertAdjacentElement('afterbegin', container)
		container.insertAdjacentElement('afterbegin', dismiss)
		container.insertAdjacentElement('afterbegin', content)
		document.body.insertAdjacentElement('beforeend', backdrop)

		const open = (e) => {
			e.stopPropagation()
			e.stopImmediatePropagation()
			e.preventDefault()

			this.$scrollLock.lock(header);

			main ? (main.classList.add('is-blurred'), header.classList.add('is-blurred')) : false
			backdrop.classList.add('is-active')
		}
		const close = (e) => {
			e.stopPropagation()
			e.stopImmediatePropagation()
			e.preventDefault()

			this.$scrollLock.unlock(header);
			
			main ? (main.classList.remove('is-blurred'), header.classList.remove('is-blurred')) : false
			backdrop.classList.remove('is-active')
		}

		this.$addEvents(backdrop, 'click.self', close)
		this.$addEvents(trigger, 'click.self.stop.prevent', open)
		this.$addEvents(dismiss, 'click.self.stop.prevent', close)
  }
});
